<template>
    <v-container lighten-5>
        <v-row v-if="loadingForm" align="center" justify="center">
            <v-col cols="12" sm="12" md="12" lg="12">
                <Loader />
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="auto" md="12">
                <v-form @submit.prevent="agregar">
                    <v-card elevation="0" class="rounded-xl">
                        <v-card-title>
                            <span class="headline">{{formTitle}} persona</span>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <div class="flex-grow-1"></div>
                            <v-btn color="primary darken-1" text :to="{name:'Personas'}">Cancelar</v-btn>
                            <v-btn color="primary darken-1" :loading="loadingGuardar" dark @click="agregar">Guardar</v-btn>
                        </v-card-actions>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        Datos de la persona
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                        <v-text-field dense outlined v-on:keyup="$data.form.copeNombre = $event.target.value.toUpperCase()" :error-messages="errores['copeNombre']" label="Nombre" v-model="form.copeNombre"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                        <v-text-field dense outlined v-on:keyup="$data.form.copeIdentificacion = $event.target.value.toUpperCase()" label="Identificacion" :error-messages="errores['copeIdentificacion']" v-model="form.copeIdentificacion"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                        <v-autocomplete dense outlined v-model="form.copeTipoIdentificacion" :error-messages="errores['copeTipoIdentificacion']" :items="tipoidentificacion" item-text="comaNombrelargo" item-value="comaId" item-color="primary" label="Tipo de identificacion" clearable></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                        <v-text-field dense outlined v-on:keyup="$data.form.copeTelefono = $event.target.value.toUpperCase()" label="Telefono" v-model="form.copeTelefono"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field dense outlined label="Email" v-model="form.copeEmail"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field dense outlined v-on:keyup="$data.form.copeDireccion = $event.target.value.toUpperCase()" label="Direccion" v-model="form.copeDireccion"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                        <v-switch dense v-model="form.esEgresado" label="Es graduado"></v-switch>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                        <v-switch dense v-model="form.esEmpleado" label="Es funcionario"></v-switch>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                        <v-switch dense v-model="form.esEstudiante" label="Es estudiante"></v-switch>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                        <v-switch dense v-model="form.esDocente" label="Es docente"></v-switch>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4" v-if="user.role.indexOf('ADMIN') > -1">
                                        <v-autocomplete dense outlined v-model="form.userId" :items="users.users" item-text="username" item-value="id" label="Usuario" :search-input.sync="users.search"  @keyup="searchUser()" required hide-no-data hide-selected clearable> </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea label="Observacion" dense outlined v-model="form.link"></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-btn color="info" @click="dialog = true">
                                            DETALLES
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-divider></v-divider>
                    </v-card>
                </v-form>
            </v-col>
            <v-dialog v-model="dialog" persistent width="1200px" max-width="1200px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Valores</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row v-for="(valor,index) in form.carnets" :key="'DETALLE'+index">
                                    <v-col cols="12" sm="12" md="3" >
                                       <v-autocomplete dense outlined v-model="valor.cocaTipo"  :items="['GRADUADO','ESTUDIANTE','FUNCIONARIO','DOCENTE']" item-color="primary" label="Tipo carnet" ></v-autocomplete>
                                    </v-col>
                                    <template v-if="valor.cocaTipo">
                                      <v-col cols="12" sm="12" md="6" v-if="['GRADUADO','ESTUDIANTE'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Programa" v-model="valor.programa"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['GRADUADO'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Acta" v-model="valor.acta"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['GRADUADO'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Folio" v-model="valor.folio"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['GRADUADO'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Libro" v-model="valor.libro"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['GRADUADO'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Fecha de grado" v-model="valor.fecha_grado"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['ESTUDIANTE'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Semestre" v-model="valor.semestre"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['ESTUDIANTE'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Tipo de estudiante" v-model="valor.tipo"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['ESTUDIANTE'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Facultad" v-model="valor.facultad"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['FUNCIONARIO'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Apoyo" v-model="valor.apoyo"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['FUNCIONARIO'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Cargo" v-model="valor.cargo"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['ESTUDIANTE'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Sede" v-model="valor.sede"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['ESTUDIANTE'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Universidad de origen" v-model="valor.universidad_origen"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="6" v-if="['FUNCIONARIO'].some(e => e.indexOf(valor.cocaTipo) > -1)">
                                          <v-text-field dense outlined label="Tipo de vinculacion" v-model="valor.tipo_vinculacion"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="2" >
                                          <v-switch dense v-model="valor.is_visible" label="Visible"></v-switch>
                                      </v-col>
                                      <v-col cols="auto" sm="12" md="2" >
                                          <v-btn text icon color="success" @click="agregarValor()">
                                              <v-icon>mdi-plus</v-icon>
                                          </v-btn>
                                          <v-btn text icon color="error" v-if="index > 0" @click="eliminarValor(valor)">
                                              <v-icon>delete</v-icon>
                                          </v-btn>
                                      </v-col>
                                    </template>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn color="primary darken-1" text @click="dialog = false">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import generales from '../../../mixins/generales.js';
export default {
  mixins: [generales],
  name: 'Createpersona',
  data() {
    return {
      menu: false,
      url: 'sistema/personas/',
      nuevo: false,
      form: {
        copeId: null,
        copeTelefono: null,
        copeEmail: null,
        copeDireccion: null,
        copeIdentificacion: null,
        copeTipoIdentificacion: null,
        userId: null,
        copeNombre: null,
        esEgresado: 0,
        esEmpleado: 0,
        esEstudiante: 0,
        carnets:[
          {
            cocaTipo: null,
            programa:null,
            acta: null,
            folio: null,
            libro: null,
            fecha_grado: null,
            semestre: null,
            tipo: null,
            facultad: null,
            copeId: null,
            apoyo:null,
            cargo:null,
            sede:null,
            universidad_origen:null,
            tipo_vinculacion:null,
            is_visible:1
          }
      ]
      },
      tipoidentificacion: [],
       users: {
        users: [],
        search: null,
        error: "",
        isLoading: false
      },
    }
  },
  created: async function() {
    this.loadingForm = true;
    let {
      tipoidentificacion
    } = await this.$apiService.index("sistema/personas/generalesCreate").then(data => data);
    this.tipoidentificacion = tipoidentificacion;
    this.form.createdBy = this.user.id
    if (this.$route.params.id) {
      await this.editar(this.$route.params.id);
    }
    this.form.copeTipoIdentificacion = tipoidentificacion.find(e => e.comaNombrecorto == 'CC').comaId
    this.loadingForm = false;
  },
  computed: {
    formTitle() {
      return this.isNew === true ? "Registrar nuevo" : "Actualizar";
    },
  },
  methods: {
    async searchUser() {
      this.users.isLoading = true;
      if (this.users.search.length > 0 && this.users.search.toString().replace(/ /g, "") != "") {
        this.$apiService.index("sistema/user/buscar2?username=" + this.users.search.toUpperCase()).then(data => {
          this.users.users = data;
        });
      }
      this.users.isLoading = false;
    },
    agregarValor() {
      this.form.carnets.push({
            cocaTipo: null,
            programa:null,
            acta: null,
            folio: null,
            libro: null,
            fecha_grado: null,
            semestre: null,
            tipo: null,
            facultad: null,
            copeId: null,
            apoyo:null,
            cargo:null,
            sede:null,
            universidad_origen:null,
            is_visible:1
          })
    },
    eliminarValor(valor) {
      this.form.carnets = this.form.carnets.filter(e => e != valor)
    },
    async editar(id) {
      try {
        this.form = await this.$apiService.index(this.url + "view/" + id).then(data => data);
        this.isNew = false;
      } catch (error) {
        this.$swal.fire({
          title: "Algo sucedio!",
          text: "contacta con el administrador",
          icon: "error"
        });
      }

    },

    async agregar() {
      try {
        this.errores = [];
        this.loadingGuardar = true;
        let data = (this.isNew) ? await this.$apiService.create(`${this.url}create`, this.form).then((data) => data) :
          await this.$apiService.update(`${this.url}update/${this.form.copeId}`, this.form).then((data) => data);
        if (data) {
          this.$swal.fire({
            title: "Completado!",
            text: "Registro exitoso",
            icon: "success",
            confirmButtonText: "Ok"
          });
          if (this.isNew) {
            this.limpiar()
            this.form.copeTipoIdentificacion = this.tipoidentificacion.find(e => e.comaNombrecorto == 'CC').comaId
          } else {
            this.$router.push("/sistema/personas");
          }
        }

      } catch (error) {
        if (error.response && 422 == error.response.status) {
          this.errores = error.response.data.errors;
        } else {
          if (error.response && 403 == error.response.status) {
            this.$router.push('/403');
          } else {
            if (error.response && 400 == error.response.status && error.response.data.message) {
              this.$swal.fire({
                title: "Ups!",
                text: error.response.data.message,
                icon: "info"
              });
            } else {
              console.log(error)
              this.$swal.fire({
                title: "Algo sucedio!",
                text: "contacta con el administrador",
                icon: "error"
              });
            }
          }

        }
      }
      this.loadingGuardar = false;
    },
    limpiar() {
      this.form = {
        copeId: null,
        copeTelefono: null,
        copeEmail: null,
        copeDireccion: null,
        copeIdentificacion: null,
        copeTipoIdentificacion: null,
        userId: null,
        copeNombre: null,
        esEgresado: 0,
        esEmpleado: 0,
        esEstudiante: 0,
        createdBy: this.user.id,
        carnets:[
          {
            cocaTipo: null,
            programa:null,
            acta: null,
            folio: null,
            libro: null,
            fecha_grado: null,
            semestre: null,
            tipo: null,
            facultad: null,
            copeId: null,
            apoyo:null,
            cargo:null,
            sede:null,
            universidad_origen:null,
            is_visible:1
          }
      ]
      };
    },

  }

}

</script>
